import { useMemo } from "react";
import { FeatureKey, useRemoteConfigJSON } from "@repo/utils";
import {
  SCORE_LANDING_PAGE_FALLBACK,
  type ScoreLandingPageResponse,
} from "../../../shared/score2026";
import { parseScoreLandingPage } from "../../../shared/scoreRegistration";

export function useScoreLandingPageRemoteConfig(): {
  scoreLandingPage: ScoreLandingPageResponse;
  isInitialized: boolean;
} {
  const { value: raw, isInitialized } =
    useRemoteConfigJSON<ScoreLandingPageResponse>(
      FeatureKey.SCORE_2026,
      SCORE_LANDING_PAGE_FALLBACK,
    );

  const scoreLandingPage = useMemo(
    () => parseScoreLandingPage(raw) ?? SCORE_LANDING_PAGE_FALLBACK,
    [raw],
  );

  return { scoreLandingPage, isInitialized };
}
